import {
  cryptoUint32,
  randomInt,
  type Uint32Source,
} from "@/lib/tool-kit/random-fun/rng";

export interface Roll {
  notation: string;
  /** The sides each die of this roll had — the roll remembers them, the settings may move on. */
  sides: number;
  dice: number[];
  total: number;
}

/** `count` dice of `sides` faces, each face exactly as likely as any other. */
export function rollDice(
  count: number,
  sides: number,
  source: Uint32Source = cryptoUint32
): Roll {
  const dice: number[] = [];
  for (let i = 0; i < count; i += 1) {
    dice.push(randomInt(1, sides, source));
  }
  const total = dice.reduce((sum, value) => sum + value, 0);
  return { notation: `${count}d${sides}`, sides, dice, total };
}

/** The lowest total a roll like this one could give: every die showing 1. */
export function minimumPossible(roll: Roll): number {
  return roll.dice.length;
}

/** The highest total a roll like this one could give, from the roll's own dice. */
export function maximumPossible(roll: Roll): number {
  return roll.dice.length * roll.sides;
}
